import React from 'react';
import PropTypes from 'prop-types';

import DropDownButton from 'components/form/DropDownButton';

function SupportDropDown(props) {
    return (
        <DropDownButton label={gettext('Support')}>
            <ul>
                <a href={Util.reverseURL('general:help_page')}>
                    <li>{gettext('Site Help')}</li>
                </a>

                {
                    !props.gateway &&
                    <div>
                        <a href={Util.reverseURL('services:list')}>
                            <li>{gettext('Support Services')}</li>
                        </a>
                        <a href={Util.reverseURL('services:site_feedback')}>
                            <li>{gettext('Send Us Feedback')}</li>
                        </a>
                    </div>
                }

                <a href={Util.reverseURL('services:contact')}>
                    <li>{gettext('Contact Us')}</li>
                </a>
            </ul>
        </DropDownButton>
    );
}

SupportDropDown.propTypes = {
    gateway: PropTypes.string
};

SupportDropDown.defaultProps = {
    gateway: ''
};

export default SupportDropDown;



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/SupportDropDown.jsx